import dayjs, { Dayjs } from "utils/dayjs";
import AmountWithCurrency, { IAmountWithCurrencyDto } from 'models/AmountWithCurrency';
import { toDateWithoutTimezone } from 'utils/utils';

export interface IMonthlyRentalCostDto {
    validFrom?: string | null
    validTo?: string | null
    rentalCost: IAmountWithCurrencyDto
}

export default class MonthlyRentalCost {
    validFrom?: Dayjs | null
    validTo?: Dayjs | null
    rentalCost: AmountWithCurrency

    constructor({ validFrom,validTo, rentalCost }: IMonthlyRentalCostDto) {
        this.validFrom = validFrom ? dayjs.utc(validFrom, "YYYY-MM-DD") : null
        this.validTo = validTo ? dayjs.utc(validTo, "YYYY-MM-DD") : null
        this.rentalCost = new AmountWithCurrency(rentalCost)
    }

    toDto(): IMonthlyRentalCostDto {
        return {
            validFrom: this.validFrom ? toDateWithoutTimezone(this.validFrom) : null,
            validTo: this.validTo ? toDateWithoutTimezone(this.validTo) : null,
            rentalCost: this.rentalCost
        }
    }

}
